module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"not-found":"not found","description":"there\u0027s nothing here.","back":"back to homepage","home":"home"}}')
  delete Component.options._Ctor
}
